import React from 'react';
import { XCircleIcon } from 'lucide-react';
const problems = ['You arrive at training without a real plan', 'You spend hours preparing sessions before every training', 'You keep searching for new drills online', 'Skill levels in your squad vary wildly', "You don't know how to structure a full season progression", 'Sessions always feel improvised'];
export function ProblemSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-193" data-mp="39hcsnyeqcr87">
      <div className="mx-auto max-w-4xl text-center" data-id="element-194" data-mp="39g2t14s8bazg">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-[#d4af37]" data-id="element-195" data-mp="35h2c5rtbaif3">
          The coaching reality
        </p>
        <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-196" data-mp="3jer058ioe5od">
          If you coach rugby, you probably know these problems.
        </h2>
        <div className="mt-10 grid gap-3 text-left sm:grid-cols-2" data-id="element-197" data-mp="1p33t8nmieerm">
          {problems.map(problem => <div key={problem} className="flex gap-3 border border-white/10 bg-[#16161F] p-4" data-id="element-198" data-mp="1k3r41w860vlv">
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-199" data-mp="jdwmj2snhwz0" />
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-200" data-mp="obyekd8216mm">
                {problem}
              </p>
            </div>)}
        </div>
        <p className="mt-10 font-display text-3xl font-bold uppercase leading-none text-[#d4af37] sm:text-4xl" data-id="element-201" data-mp="sc8mvwjbk94n">
          How many more sessions do you want to keep improvising?
        </p>
      </div>
    </section>;
}